import MyClassicEditor from "ckeditor/myck_classic_editor.js"
window.MyClassicEditor = MyClassicEditor;